import { Badge, Radio as AntRadio, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled from 'styled-components';

import SwapUserIcon from '../../../assets/img/SwapUserIcon';
import { USERS_ACTIONS } from '../../store/actions/reducer-actions/users';
import { Colors } from '../../styles/vars';
import { connect } from '../../utils/redux';
import Button from './Button';
import Flex from './containers/Flex';
import PageTitle from './PageTitle';
import Popup from './Popup';

const StyledRadio = styled(AntRadio)`
  > span:not(.ant-radio) {
    width: 100%;
  }
`;

const MultiAccountSelector = ({ currentUser, setMultiAccountCurrentUser }) => {
  const [selectedUser, setSelectedUser] = useState(null);

  if (!currentUser || !currentUser.isMultiAccount) {
    return null;
  }

  const options = currentUser.availableMultiAccountUsers.map(
    ({ sCustomerCode, sCustomerName, iPendingDraftOrders }) => ({
      value: sCustomerCode,
      label: sCustomerName,
      pendingDraftOrders: Number.parseInt(iPendingDraftOrders, 10) || 0,
    }),
  );

  const handleOnChange = event => {
    if (event.target.value) {
      setSelectedUser(event.target.value);
    }
  };

  const handleOnClose = event => {
    const { popupSuccess } = event.detail;

    if (popupSuccess) {
      setMultiAccountCurrentUser(selectedUser);
    }
  };

  return (
    <Popup
      backgroundColor={Colors.white}
      confirmButton={({ onClick }) => (
        <Button
          color={Colors.white}
          background={Colors.accent}
          disabled={!selectedUser}
          onClick={onClick}
        >
          <span>Valider</span>
        </Button>
      )}
      onClose={handleOnClose}
      style={{ padding: '16px 40px' }}
      dismissible={false}
      open={currentUser.shouldSelectMultiAccountUser}
    >
      <Flex direction="column" style={{ width: '100%', height: '100%' }}>
        <PageTitle
          fromComponent="h2"
          margin="0 0 1em 0"
          fontSize="22px"
          style={{ flexShrink: 0 }}
          icon={<SwapUserIcon size={18} />}
        >
          Sélectionnez le compte à utiliser
        </PageTitle>

        <AntRadio.Group
          value={selectedUser}
          onChange={handleOnChange}
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            width: '100%',
          }}
        >
          {options.map(option => (
            <StyledRadio key={option.value} value={option.value}>
              <Flex
                justify="space-between"
                align="center"
                gap="20px"
                style={{ width: '100%' }}
              >
                <div>{option.label}</div>

                {option.pendingDraftOrders > 0 && (
                  <Tooltip
                    title={`${option.pendingDraftOrders} projet${
                      option.pendingDraftOrders > 1 ? 's' : ''
                    } de commande en attente de validation`}
                    zIndex={950}
                    color={Colors.darkerGrey}
                    overlayInnerStyle={{ textAlign: 'center' }}
                    arrowPointAtCenter
                  >
                    <Badge
                      count={option.pendingDraftOrders}
                      color={Colors.primary}
                      title=""
                    />
                  </Tooltip>
                )}
              </Flex>
            </StyledRadio>
          ))}
        </AntRadio.Group>
      </Flex>
    </Popup>
  );
};

MultiAccountSelector.propTypes = {
  currentUser: PropTypes.oneOfType([
    PropTypes.objectOf(PropTypes.any),
    v => v === null,
  ]),

  setMultiAccountCurrentUser: PropTypes.func.isRequired,
};

MultiAccountSelector.defaultProps = {
  currentUser: null,
};

export default connect(state => ({ ...state.users }), {
  ...USERS_ACTIONS,
})(MultiAccountSelector);
